module.exports = __webpack_public_path__ + "39e4b42518614d1c4f8d51c7ce4236d3.pdf";